var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 204,
    viewBox: "0 0 180 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.342 177.369C150.099 168.099 179.714 132.436 179.714 89.8571C179.714 40.2304 139.484 0 89.8571 0C40.2304 0 0 40.2304 0 89.8571C0 132.437 29.6159 168.099 69.3723 177.369L82.2828 199.644C85.6493 205.452 94.0654 205.452 97.4318 199.644L110.342 177.369Z",
    fill: "#BC323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4504 55.0622C86.4504 65.5166 79.1861 73.9916 70.2252 73.9916C61.2643 73.9916 54 65.5166 54 55.0622C54 44.6078 61.2643 36.1328 70.2252 36.1328C79.1861 36.1328 86.4504 44.6078 86.4504 55.0622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9836 73.3703C75.928 70.7109 73.7562 68.584 71.0962 68.584C68.4363 68.584 66.2646 70.7107 66.2088 73.37L64.9672 132.636C64.8952 136.07 67.6596 138.893 71.0946 138.893C74.5296 138.893 77.2939 136.071 77.2221 132.636L75.9836 73.3703Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.454 39.726C121.359 37.6842 119.64 36.0982 117.597 36.1672C115.554 36.2362 113.946 37.9346 113.989 39.9781L115.965 134.039C116.022 136.789 118.317 138.961 121.066 138.868C123.815 138.775 125.958 136.453 125.83 133.705L121.454 39.726Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.019 39.9475C108.044 37.9037 106.421 36.2199 104.377 36.1692C102.334 36.1186 100.63 37.7199 100.553 39.7623L97.0192 133.777C96.9159 136.526 99.0795 138.829 101.829 138.897C104.579 138.965 106.854 136.773 106.887 134.022L108.019 39.9475Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/Restaurant.24c77fa23500f0149cbcc1f04ecdc3c9.svg";
export { ForwardRef as ReactComponent };